import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useSearchPageQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/__internal__/useSearchPageQuery";
import getFeaturedBrands from "@faire/web-api--source/api/v3/search/products/featured-brands/post";
import { IGetFeaturedBrandsRequest } from "@faire/web-api--source/indigofair/data/IGetFeaturedBrandsRequest";
import { IGetFeaturedBrandsResponse } from "@faire/web-api--source/indigofair/data/IGetFeaturedBrandsResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
var SEARCH_PAGE_FEATURED_BRANDS_QUERY_KEY = "SearchPageFeaturedBrands";
export var useSearchPageBrandTilesRelatedToSearch = function() {
    var hookEnabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var _query_data, _query_data1;
    var searchPageData = useSearchPageQuery().data;
    var searchPageIsFetching = useSearchPageQuery().isFetching;
    var productTokens = useMemo(function() {
        var _searchPageData_product_tiles;
        return searchPageData === null || searchPageData === void 0 ? void 0 : (_searchPageData_product_tiles = searchPageData.product_tiles) === null || _searchPageData_product_tiles === void 0 ? void 0 : _searchPageData_product_tiles.map(function(p) {
            var _p_product;
            return (_p_product = p.product) === null || _p_product === void 0 ? void 0 : _p_product.token;
        }).filter(function(token) {
            return !!token;
        });
    }, [
        searchPageData === null || searchPageData === void 0 ? void 0 : searchPageData.product_tiles
    ]);
    var irrelevantProductTokens = useMemo(function() {
        var _searchPageData_irrelevant_product_tiles;
        return searchPageData === null || searchPageData === void 0 ? void 0 : (_searchPageData_irrelevant_product_tiles = searchPageData.irrelevant_product_tiles) === null || _searchPageData_irrelevant_product_tiles === void 0 ? void 0 : _searchPageData_irrelevant_product_tiles.map(function(p) {
            var _p_product;
            return (_p_product = p.product) === null || _p_product === void 0 ? void 0 : _p_product.token;
        }).filter(function(token) {
            return !!token;
        });
    }, [
        searchPageData === null || searchPageData === void 0 ? void 0 : searchPageData.irrelevant_product_tiles
    ]);
    var query = useQuery({
        queryKey: [
            SEARCH_PAGE_FEATURED_BRANDS_QUERY_KEY,
            productTokens,
            irrelevantProductTokens,
            searchPageData === null || searchPageData === void 0 ? void 0 : searchPageData.request_id
        ],
        queryFn: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var signal, _searchPageData_request_id;
                return _ts_generator(this, function(_state) {
                    signal = param.signal;
                    if (!productTokens.length) {
                        return [
                            2,
                            IGetFeaturedBrandsResponse.build({})
                        ];
                    }
                    return [
                        2,
                        getFeaturedBrands(IGetFeaturedBrandsRequest.build({
                            product_tokens: _to_consumable_array(productTokens !== null && productTokens !== void 0 ? productTokens : []).concat(_to_consumable_array(irrelevantProductTokens !== null && irrelevantProductTokens !== void 0 ? irrelevantProductTokens : [])),
                            request_id_from_parent_search_response: (_searchPageData_request_id = searchPageData === null || searchPageData === void 0 ? void 0 : searchPageData.request_id) !== null && _searchPageData_request_id !== void 0 ? _searchPageData_request_id : ""
                        }), {
                            signal: signal
                        })
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        enabled: productTokens && productTokens.length > 0 && !searchPageIsFetching && hookEnabled,
        staleTime: Infinity,
        placeholderData: keepPreviousData
    });
    return {
        brandTilesRelatedToSearch: (_query_data = query.data) === null || _query_data === void 0 ? void 0 : _query_data.brand_tiles,
        isFetching: query.isFetching,
        requestId: (_query_data1 = query.data) === null || _query_data1 === void 0 ? void 0 : _query_data1.request_id
    };
};
